import { useMemo } from 'react'
import { compareNumericString } from '../../../../../utils'

const sharedAttrs = { alignRight: true, width: 50 }

export const defaultColumnConfig = {
  columns: [
    { Header: 'Identifier', accessor: 'nodeName', width: 50 },
    { Header: 'Name', id: 'name', accessor: (d) => d.assetName || d.classificationType, width: 100 },
    { id: 'Type', Header: 'Type', accessor: 'nodeType', ...sharedAttrs },
    { id: 'allocation', Header: 'Allocation', accessor: 'allocation', ...sharedAttrs, format: 'percentage', sortType: compareNumericString }
  ],
  defaultSort: [{ id: 'allocation', desc: true }]
}

export const useColumns = ({
  formatter,
  columnConfig = defaultColumnConfig
}) => {
  return useMemo(() => {
    const { columns, defaultSort } = columnConfig
    const mapColumns = columns => {
      if (!columns) return undefined
      return columns.map(column => {
        const formatString = column.format

        return {
          ...column,
          Cell: ({ value }) => formatter(value, formatString),
          columns: mapColumns(column.columns)
        }
      })
    }
    const templatedColumns = mapColumns(columns)

    return {
      columns: templatedColumns,
      defaultSort
    }
  }, [columnConfig, formatter])
}
